module.exports = __webpack_public_path__ + "60fa3c0614b8fb2f394fa29944c21540.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-Regular.woff
// module id = 345
// module chunks = 0